<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <div v-if="open">
    <v-overlay

    ></v-overlay>

    <v-navigation-drawer
        permanent right
        absolute
        class="drawer"
        width="900"
    >

      <!--<v-card>-->
      <v-btn fab small fixed top left outlined color="primary"
             v-if="slip.code && this.slips.length > 1"
             :disabled="this.slips.length < 2"
             @click="onClickPrevious()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-btn fab small fixed top right outlined color="primary"
             v-if="slip.code && this.slips.length>1"
             :disabled="this.slips.length < 2"
             @click="onClickNext()">
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>


      <v-content>
        <v-card-title v-if="slip.code" class="headline">
          {{slip.code}}

          <!--<v-btn class="headline_status" small tile :color="SlipConst.color(slip.status)">-->
          <!--{{SlipConst.map(slip.status)}}-->
          <!--</v-btn>-->
        </v-card-title>

        <!--<v-card-text>Info</v-card-text>-->

        <div class="contents">
          <v-card>
            <v-container class="container--fluid pt-0">
              <v-row>
                <v-col>

                  รหัสพนักงาน: {{slip.user_code}}<br/>
                  ชื่อ: {{slip.user.name}}<br/>
                  จ่ายเมื่อ: {{$helper.date_format(slip.paid_at)}}

                </v-col>
                <v-col class="col-6 text-right">
                  <span class="">ใบเสร็จเมื่อ {{$helper.date_format_short(slip.receipt_from)}} - {{$helper.date_format_short(slip.receipt_to)}} </span><br/>
                  <span class="">ค่าคอมฯ {{$helper.number_format(slip.total_internal_amount,2,2)}} บาท</span><br/>
                  <span class="">คอมฯนอก {{$helper.number_format(slip.total_external_amount,2,2)}} บาท</span>

                </v-col>
              </v-row>
            </v-container>
          </v-card>
          <!--{{slip}}-->


          <v-content>

            <v-container
                class="fill-height container"
                fluid
                child-flex
                v-if="slip.records && slip.records.length>0"
            >

              <v-data-table
                  v-if="slip && slip.records && Array.isArray(slip.records)"
                  :loading="this.isLoadSlip"
                  :headers="[
                      {text: 'สั่ง', value: 'erp_so_at'},

                      {text: 'ใบเสร็จ', value: 'receipt_code'},
                      {text: 'ลูกค้า', value: 'customer'},
                      {text: 'ยอดหาร', value: 'commission_value', align: 'end'},
                      {text: 'ค่าคอม', value: 'total_external_discount', align: 'end'},
                      ]"
                  :options="{
                    itemsPerPage: 8,
                  }"
                  :items="slip.records"
                  class="elevation-1 tr-clickable"
                  @click:row="(item,debug)=>openOrder({order:item.order,debug:debug})"
              >


                <template v-slot:item.erp_so_at="{ item }">
                  {{ item.order.erp_so_at?$helper.date_format_short(item.order.erp_so_at):
                  (item.order.submitted_at?$helper.date_format_short(item.order.submitted_at):'')
                  }}
                </template>


                <template v-slot:item.receipt_code="{ item }">
                  {{ item.order.receipt_date?$helper.date_format_short(item.order.receipt_date):''}} {{
                  item.order.receipt_code }}<br/>
                  <!--<div style="text-align: right">{{ $helper.number_format(item.order.total_gross,2,2) }}</div>-->
                </template>

                <template v-slot:item.invoice_code="{ item }">
                  {{item.order.invoice_code}}
                </template>
                <template v-slot:item.customer="{ item }">
                  <span style="float:right">{{item.order.customer?item.order.customer.province:''}}</span>
                  {{item.order.code}}<br/>
                  {{item.order.customer?item.order.customer.nickname:item.order.customer_code}}<br/>
                </template>
                <template v-slot:item.total_gross="{ item }">
                  {{ $helper.number_format(item.order.total_gross,2,2) }}
                </template>
                <template v-slot:item.commission_value="{ item }">
                  {{ $helper.number_format(item.order.total_commission_able,2,2) }}
                  <span v-if="item.order.total_commission_able!=item.order.total_gross"><br/>
                    / {{ $helper.number_format(item.order.total_gross,2,2) }}</span>

                </template>
                <template v-slot:item.total_external_discount="{ item }">

                  {{ $helper.number_format(item.slip_paid_internal,2,2)}}
                  <span v-if="item.slip_paid_external>0">
                      <br/> + {{ $helper.number_format(item.slip_paid_external,2,2) }}
                    </span>

                </template>
              </v-data-table>

            </v-container>
          </v-content>


          <!--<v-footer class="pb-10">-->
          <!--<v-container>-->
          <!--<v-row>-->
          <!--<v-col>-->
          <!--เซลล์ <span>คอมฯนอก {{slip.total_external_discount}} บาท</span>-->

          <!--<v-divider class="mb-4"></v-divider>-->


          <!--</v-col>-->
          <!--<v-col class="col-2 text-right">-->
          <!--Gross<br/>-->
          <!--Vat<br/>-->
          <!--Net-->
          <!--</v-col>-->
          <!--<v-col class="col-2 text-right">-->
          <!--{{$helper.number_format(slip.total_gross,2)}}<br/>-->
          <!--{{$helper.number_format(slip.total_vat,2)}}<br/>-->
          <!--{{$helper.number_format(slip.total_net,2)}}-->
          <!--</v-col>-->
          <!--</v-row>-->

          <!--</v-container>-->
          <!--</v-footer>-->
        </div>
      </v-content>


      <v-btn float fab fixed bottom right class="close-button" color="primary"
             :loading="is_LoadSubmitSlip"
             @click="()=>{this.close()}">
        <v-icon>mdi-close</v-icon>
      </v-btn>


      <!--</v-card>-->
      <!--</v-dialog>-->
    </v-navigation-drawer>

  </div>
</template>
<style lang="scss" scoped>
  .contents {
    height: calc(100vh - 80px);
    overflow: auto;
  }

  .headline {
    padding-top: 20px;
    padding-bottom: 0;
    height: 56px;
  }

  .headline_status {
    margin-left: 10px;
  }

  .overlay {
    z-index: 5 !important;
  }

  .drawer {
    z-index: 6 !important;
  }

  .view {
    z-index: 6 !important;
    .v-card__title {
      padding-left: 68px;
      padding-right: 68px;
    }
    .v-app-bar {
      padding-right: 96px;
    }
  }

  .item-qty {
    min-width: 80px;
  }

  .list-container {
    .list-row {
      position: relative;
      height: auto;
      margin-left: 0;
    }
    .list-row {
      font-size: 20px;
    }
    @media all and (max-width: 599px) {
      .list-row {
        font-size: 16px;
      }
    }
    @media all and (min-width: 600px) and (max-width: 720px) {
      .list-row {
        font-size: 18px;
      }
    }
    @media all and (min-width: 720px) and (max-width: 960px) {
      .list-row {
        font-size: 20px;
      }
    }
  }

  .itemTable {

    line-height: 1.2;
  }

  .ItemHead {
    th {
      font-size: 16px;
    }
  }

  .ItemRow {
    td {
      font-size: 16px;
      padding: 0 4px;
    }
    td:first-child {
      font-size: 16px;
      padding-left: 8px;
    }
    td:last-child {
      padding-right: 8px;
    }
  }

</style>
<script lang="ts">


  import {Component, Vue} from 'vue-property-decorator'
  import CreditBar from '../components/Customer/CreditBar.vue'
  import TypeBadge from '../components/Customer/TypeBadge.vue'
  import ItemRow from '../components/Order/ItemRow.vue'
  import TabForDialog from '../components/TabForDialog.vue'
  import Avatar from '../components/User/Avatar.vue'
  import {OrderUserConst} from '../models/OrderUser'
  import {DataSlip, Slip, SlipConst} from '../models/Slip'
  import {User} from '../models/User'
  import Helper from '../services/Helper.js'

  @Component({
    components: {Avatar, TypeBadge, TabForDialog, ItemRow, CreditBar},
  })
  export default class SlipDialog extends Vue {

    open = false

    isOpenSaleCondition = false
    isSaveSaleCondition = false


    OrderUserConst = OrderUserConst

    com_option = OrderUserConst.COM_OPTION_NORMAL

    onApply: Function = () => {

    }


    index = 0
    slips = []

    onOpen({id, slip, slips, index, debug, skip_load, onApply}) {
      if (this.open) return
      console.log('Emited', {slip, slips, index, debug})
      this.slip = new Slip()
      if (slip) {
        this.slip = slip
      } else if (id) {
        this.slip.id = id
      }
      if (index && slips) {
        this.index = index
        this.slips = slips
      } else {
        this.index = 0
        this.slips = []
      }
      if (this.slip.user === null) {
        this.slip.user = new User()
      }
      this.open = true

      if (skip_load) {

      } else {
        this.getSlip()
      }
      this.onApply = onApply
    }


    mounted() {
      this.$root.$on('openSlip', this.onOpen)
    }


    SlipConst = SlipConst

    dialog: boolean = false


    onClickPrevious() {
      if (this.slips.length > 1) {
        this.index = (this.index - 1) % this.slips.length
        this.slip = this.slips[this.index]
        this.getSlip()
      }
    }

    onClickNext() {
      if (this.slips.length > 1) {
        this.index = (this.index + 1) % this.slips.length
        this.slip = this.slips[this.index]
        this.getSlip()
      }
    }


    slip: Slip = new Slip()
    isLoadSlip = false

    getSlip() {
      const id = this.slip.id
      this.isLoadSlip = true
      Helper.get(Helper.setting.slip.getResourceAPI.replace('{id}', id))
        .then<{ data: DataSlip }>(({data}) => {

          console.log('getSlip', data.data)
          this.slip = data.data

          this.isLoadSlip = false
        })

    }


    is_LoadSubmitSlip = false

    async ApproveSlip() {
      await this.SetSlipStatus(SlipConst.STATUS_APPROVED)
    }

    async RejectSlip() {
      await this.SetSlipStatus(SlipConst.STATUS_REJECT)
    }

    async CancelSlip() {
      await this.SetSlipStatus(SlipConst.STATUS_PENDING)
      this.close()
    }


    close() {
      this.open = false
    }

    openOrder(option) {
      this.$root.$emit('openOrder', option)
    }


    async SetSlipStatus(status: number) {
      if (this.slip.status == status) return
      let slip: Slip = new Slip()
      slip.id = this.slip.id
      slip.mode = 'status'
      if (!slip.hasOwnProperty('SetStatus')) {
        slip = Object.setPrototypeOf(slip, Slip.prototype)
      }
      this.is_LoadSubmitSlip = true
      // debugger
      try {
        slip = await slip.SetStatus(status)
        this.slip = slip
      } catch (e) {
        // alert(e);
      }
      this.is_LoadSubmitSlip = false
      return slip
    }


  };

</script>
